import { SimulatorUI } from '@fruitful/money-map-simulator';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { ScrollView, Text, YStack } from 'smoothie';

export const MoneyMapSimulatorPage = () => {
    const { moneyMap } = useLocalSearchParams<{ moneyMap?: string }>();

    return (
        <ScrollView flex={1} backgroundColor="$white">
            <YStack
                padding={24}
                gap={24}
                maxWidth={1600}
                alignSelf="center"
                width="100%"
            >
                <YStack gap={4}>
                    <Text fontSize={28} fontWeight="800">
                        Money Map Simulator (beta)
                    </Text>
                    <Text fontSize={14} color="$gray1000">
                        Simulate how money flows through a Money Map over time.
                        Edit the JSON, tweak parameters, and run month-by-month
                        projections.
                    </Text>
                </YStack>

                <SimulatorUI initialJson={moneyMap} />
            </YStack>
        </ScrollView>
    );
};
